export const initialFilterDisplayValues = () => ({
  filterShown: false,
  sortShown: false,
});

